import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TextareaInput } from '../../inputs';

export const MaxLengthValidator: () => ValidatorFn = () => {
    return (control: AbstractControl): ValidationErrors | null => {
        const internalControl = control as TextareaInput;
        if (internalControl?.value) {
            if (internalControl.value.length === internalControl.maxlength) {
                return { max_length: true };
            }
        }
        return null;
    };
};
